<div class="checkbox">
  <label>
    <input type="checkbox" [readonly]="readonly" [(ngModel)]="selected" (change)="changed($event)" (click)="clicked()">
    <span class="cr" [ngClass]="{ 'selected' : selected && !readonly, 'readonly' : readonly, 'selected-and-readonly' : selected && readonly }"><i class="cr-icon glyphicons glyphicons-ok"></i></span>
  </label>
</div>
